export default {
  GET_ACCOUNT_SETTING_DETAIL: {
    url: '/account-setting/detail',
    method: 'GET'
  },
  UPDATE_ACCOUNT_SETTING_DETAIL: {
    url: '/account-setting/update-account-setting',
    method: 'PUT'
  },
  GET_PASSWORD_REGEX: {
    url: '/account-setting/public/regex-password',
    method: 'GET'
  },
  RESET_ALL_ACCOUNT_SETTINGS: {
    url: '/account-setting/reset-account-setting',
    method: 'PUT'
  }
};
